import * as angular from 'angular';
import { ComponentDefinition } from '../../../models';

class DocumentationTreeController implements angular.IComponentController {
    isLoading: boolean;
    readonly category: string;

    // $scope seems useless
    static $inject = ['$scope'];
    constructor(private _$scope: angular.IScope) {
    }
}

export const wtDocumentationTree: ComponentDefinition = {
    componentId: 'wtDocumentationTree',
    controller: DocumentationTreeController,
    controllerAs: 'vm',
    template: require('./documentationTree.component.html'),
    bindings: {
        category: '<'
    }
};
